import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAssistanceState } from './utils';
import { TickIcon } from './icons';
import {
  CtaWrapper,
  CtaLabel,
  ReachOutButton,
  RequestedChip,
  ChipIcon,
  ChipLabel,
} from './assistance-status.styled';

/**
 * Shared assistance entry point.
 * - 'cta'       → "Need help posting these? Reach out" (underlined on the dashboard, plain in the list modal)
 * - 'requested' → "✓ Assistance requested" chip, but only where showChip is set (dashboard widget
 *                 and list modal). Without showChip the CTA simply disappears once requested.
 */
const AssistanceStatus = ({ assistance, onReachOut, showChip = false }) => {
  const { t } = useTranslation();
  const state = getAssistanceState(assistance);

  if (state === 'cta') {
    return (
      <CtaWrapper>
        <CtaLabel>{t('Need help posting these?')}</CtaLabel>
        <ReachOutButton type="button" onClick={onReachOut}>
          {t('Reach out')}
        </ReachOutButton>
      </CtaWrapper>
    );
  }

  if (state === 'requested' && showChip) {
    return (
      <RequestedChip>
        <ChipIcon>
          <TickIcon size={13} />
        </ChipIcon>
        <ChipLabel>{t('Assistance requested')}</ChipLabel>
      </RequestedChip>
    );
  }

  return null;
};

export default AssistanceStatus;
